import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { SettingsService } from '@supoui/core/services/settings.service';
import { IFinanceBridgeInvoiceLookupResponse } from '@supoui/shared/model/finance-bridge-invoice-lookup-response';
import { IFinanceBridgeSupplierDetails } from '@supoui/shared/model/finance-bridge-supplier-details';

@Injectable({
  providedIn: 'root'
})
export class FinanceBridgeService {
  constructor(private httpService: HttpService, private settingService: SettingsService,) {}

  supplierInvoiceLookup(creditorId: number, invoiceNo: string): Observable<IFinanceBridgeInvoiceLookupResponse> {
    const erpClient = 'DK';
    let envStr = '';
    if (!this.settingService.isProduction()) {
      const serverUrl = window.location.host;
      if (serverUrl.includes('-')) {
        let envSubstr = serverUrl.substr(serverUrl.lastIndexOf('-'));
        envStr = envSubstr.substr(1, envSubstr.indexOf('.') - 1)?.toUpperCase();
      }
    }
    return this.httpService.get<IFinanceBridgeInvoiceLookupResponse>(
      `services/financebridge/api/supplierinvoice/lookup?creditorId=${creditorId}&erpClient=${erpClient}&invoiceNo=${envStr}${invoiceNo}`
    );
  }

  fetchSupplierBankAccountDetails(creditorId: number): Observable<IFinanceBridgeSupplierDetails> {
    const erpClient = 'DK';
    return this.httpService.get<IFinanceBridgeSupplierDetails>(
      `services/financebridge/api/supplierinvoice/lookupSupplier?erpClient=${erpClient}&supplierId=${creditorId}`
    );
  }
}
